import React from 'react';

function CoverPage() {

    return (
        <div id="cover-page-content" className="content-block">

            <p className="content-block-text cover-page-centered cover-page-bu-title">
                Boston University College of Arts and Sciences
            </p>

            <p className="content-block-text cover-page-centered cover-page-machine-shop">
                Physics Department Machine Shop
            </p>

            <div className="bu-redline-footer" style={{ width: '80%', marginTop: '2rem' }}></div>

            <p className="content-block-text cover-page-centered"
                style={{ marginTop: '3rem' }}>
                Project N
            </p>

            <div className="cover-page-split-details"
                style={{ marginTop: '3rem' }}>

                <p className="content-block-text">
                    Client Name
                </p>
                
                <p className="content-block-text">
                    Billing date: NN/NN/NNNN
                </p>

            </div>

            {/* <!-- TOTAL COSTS --> */}
            <p className="content-block-text cover-page-centered"
                style={{ marginTop: '3rem' }}>
                Total Labor and Materials Cost:
            </p>

            <p className="content-block-text cover-page-centered">
                NN/NN/NNNN
            </p>

            {/* <!-- LABOR AND MATERIALS COSTS BREAKDOWN --> */}
            <div className="cover-page-split-details"
                style={{ marginTop: '5rem' }}>

                <div className="cover-page-labor-details">
                    
                    <p className="content-block-text labor-details-title">
                        Labor Costs
                    </p>

                </div>
    
                <div className="cover-page-materials-details">

                    <p className="content-block-text materials-details-title">
                    Materials Costs
                    </p>
                    
                </div>

            </div>

            <div 
                className="cover-page-split-details"
                style={{ marginBottom: '5rem' }}>

                <div style={{ width: 'fit-content' }}>

                    <div className="labor-details-itemized">

                        <p className="labor-itemized-detail">
                            NN.N
                            &nbsp;
                            Regular Hours
                            &nbsp;
                            $N,NNN.NN
                        </p>

                    </div>

                    <br/>

                    <div className="labor-details-itemized">

                        <p className="labor-itemized-detail">
                            NN.N
                            &nbsp;
                            Overtime Hours
                            &nbsp;
                            $N,NNN.NN
                        </p>

                    </div>

                </div>

                <div style={{ width: 'fit-content' }}>
                
                    <div className="labor-details-itemized materials-itemized-detail">

                        <p className="labor-details-itemized">
                            $NN,NNN.NN
                        </p>
                    
                    </div>
                
                </div>

            </div>

        </div>
    );
}

export default CoverPage;
